/**
 * Shared copy for the Stripe activation preface (formerly CelebrateScreen).
 */

export function buildCelebrateDescription(_formConfig, merchant) {
  let desc = "First, let's make sure you can receive donations.";

  if (merchant?.hasWebsite) {
    desc += " We'll also help you add the form to your website.";
  }

  return desc;
}

export const STRIPE_INFO_PARAGRAPHS = [
  'CharityStack uses Stripe to help organizations accept donations securely. Stripe is a trusted global payment provider, and it allows your organization’s bank account to connect directly for safe and reliable payouts.',
  'Stripe also handles important parts of the setup process, including identity verification, onboarding, and payout configuration.',
  'When we ask for your bank information, it is collected through Stripe’s secure systems so your organization can receive donations safely and in a compliant way through CharityStack.',
];
